import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { CancelBonusAssignmentResponse, CancelBonusAssignmentVariables } from '../types';

export const cancelBonusAssignmentMutation = gql`
  mutation PayrollCancelBonusAssignment($input: CancelBonusAssignmentInput!) {
    payrollCancelBonusAssignment(input: $input) {
      code
      success
      message
    }
  }
`;

export const cancelBonusAssignment = (queryVariables: CancelBonusAssignmentVariables) =>
  graphQLApi<CancelBonusAssignmentResponse, CancelBonusAssignmentVariables>({
    query: cancelBonusAssignmentMutation,
    queryVariables,
  });

export default cancelBonusAssignment;
